import { vsName as GridSettingsServiceName, GridSettingsService } from './grids/settings/gridSettingsService'
import { vsName as RecordGridName, recordGridComponentOptions } from './grids'
import { vsName as RecordGridViewName, RecordGridViewComponentOptions} from './views/recordGridView'
import { vsName as formViewName, formViewComponentOptions } from './forms/formView'
import { ServerUtility, vsName as ServerUtilityName} from './server/serverUtility'
import { DoubleClickHandlerService, vsName as DoubleClickHandlerServiceName } from './grids/cells/doubleClickHandlerService'
import { FieldConfigurationHelperService, vsName as FieldConfigurationHelperServiceName } from './forms/formly/fieldConfigurationHelpers'
import { recordSelectAyncConfig, repeaterConfig } from './forms/formly/types'
import { vsName as csvWriterName, CsvWriterProvider } from './csv/csvWriterProvider'
import { vsName as ColumnDefinitionServiceName, ColumnDefinitionService } from './grids/columns/columnDefinitionService'
import { RecordsUtilsService, vsName as RecordsUtilsServiceName} from "./utils"

export const moduleName = 'records'

const module = angular.module(moduleName, ['ui.bootstrap.modal', 'SlotTrak.UI', 'formly',])

module.config(recordSelectAyncConfig)
module.config(repeaterConfig)
module.provider(csvWriterName, CsvWriterProvider)
module.service(GridSettingsServiceName, GridSettingsService)
module.service(ServerUtilityName, ServerUtility)
module.service(DoubleClickHandlerServiceName, DoubleClickHandlerService)
module.service(FieldConfigurationHelperServiceName, FieldConfigurationHelperService)
module.service(ColumnDefinitionServiceName, ColumnDefinitionService)
module.service(RecordsUtilsServiceName, RecordsUtilsService)
module.component(RecordGridName, recordGridComponentOptions)
module.component(RecordGridViewName, RecordGridViewComponentOptions)
module.component(formViewName, formViewComponentOptions)